registerGlobal('HTFWebsocketClient');

HTFWebsocketClient._currentClient = 0;
HTFWebsocketClient._clients = {};

HTFWebsocketClient.Connect = function(url, arg, onOpen, onError, onClose, onMessage) {
	HTFWebsocketClient._currentClient++;
	var handle = HTFWebsocketClient._currentClient;
	var clients = HTFWebsocketClient._clients;

	var webSocket;
	try {
		webSocket = new WebSocket(url);
		webSocket.binaryType = 'arraybuffer';
		webSocket.onopen = function(openEvent) {
			if (!clients[handle]) return;
			dynCall('vi', onOpen, [arg]);
		};
		webSocket.onclose = function (closeEvent) {
			if (!clients[handle]) return;
			dynCall('vii', onClose, [arg, closeEvent.code]);
		};
		webSocket.onerror = function (errorEvent) {
			if (!clients[handle]) return;
			dynCall('vi', onError, [arg]);
		};
		webSocket.onmessage = function (messageEvent) {
			if (!clients[handle]) return;
			var wsMsg = new Uint8Array(messageEvent.data);
			var buffer = _malloc(wsMsg.length);
			HEAPU8.set(wsMsg, buffer);
			dynCall('viii', onMessage, [arg, buffer, wsMsg.length]);
		};
	} catch (exception) {
		console.log("Exception during connect: ");
		console.error(exception);
		return 0;
	}

	HTFWebsocketClient._clients[handle] = webSocket;
	return handle;
}

HTFWebsocketClient.Send = function(handle, data, size) {
	var client = HTFWebsocketClient._clients[handle];
	var message = HEAPU8.subarray(data, data + size);
	client.send(message);
}

HTFWebsocketClient.Close = function(handle) {
	var client = HTFWebsocketClient._clients[handle];
	client.close();
	delete HTFWebsocketClient._clients[handle];
}


//////////////////
// WEBPACK FOOTER
// /src/contrib/huuugetestframework/src/network/emscripten/WebsocketClient.js
// module id = 54
// module chunks = 0